'use strict';

(function ($) {
	// TODO AOS Scrollable animation init
	function isScrolledIntoView(elem) {
		let docViewTop = $(window).scrollTop();
		let docViewBottom = docViewTop + $(window).height();
		let elemTop = $(elem).offset().top + 100;
		let elemBottom = elemTop + $(elem).outerHeight();
		return elemBottom >= docViewTop && elemTop <= docViewBottom;
	}

	function checkAnimation() {
		$('.hidden-hd, .animate-js').each(function () {
			if (isScrolledIntoView(this)) {
				$(this).addClass('show');
			}
		});
	}

	$(window).on('scroll', checkAnimation);
	$(window).on('load', checkAnimation);

	// TODO Filter Category for FAQs
	$('body').on('click', function () {
		$('.filter-select > button').removeClass('btn-active').next().slideUp(100);
	});

	$('.filter-select').on('click', function (event) {
		event.stopPropagation();
	});

	$('.filter-select > button').on('click', function (event) {
		event.preventDefault();
		$(this).toggleClass('btn-active').next().slideToggle(100);
	});

	$('[data-search]').on('keyup', function () {
		let searchVal = $(this).val();
		let filterItems = $('[data-filter-item]');
		if (searchVal !== '') {
			filterItems.addClass('hidden');
			$('[data-filter-item][data-filter-name*="' + searchVal.toLowerCase() + '"]').removeClass('hidden');
		} else {
			filterItems.removeClass('hidden');
		}
	});

	// TODO Scroll To ID
	$(document).on('click', 'a[href^=\\#]', function (e) {
		let el = $($(this).attr('href'));
		if (el.length && el.offset()) {
			// one of those may be unnecessary
			e.preventDefault();
			$('html, body').animate(
				{
					scrollTop: el.offset().top - ($('header').height() + 50),
				},
				500,
			);
		}
	});

	// TODO Menu mobile
	$('button.burger').on('click', function () {
		$('body').toggleClass('overflowGlobal');
		$('.header-nav').toggleClass('active');
		$(this).toggleClass('burger-active');
	});

	// TODO Add functionality for the mobile menu open
	$('.header .genesis-nav-menu > ul > .menu-item-has-children').on('click', function () {
		if ($('.header').hasClass('header-mobile')) {
			$(this).toggleClass('open').children().last().slideToggle(150);
		} else {
			$(this).toggleClass('open');
		}
	});

	$('.header .genesis-nav-menu > ul > .menu-item-has-children .menu-item-has-children').on('click', function (event) {
		event.stopPropagation();
		if ($('.header').hasClass('header-mobile')) {
			$(this).toggleClass('open').children().last().slideToggle(150);
		} else {
			$(this).toggleClass('open');
		}
	});

	// TODO Header active class, CTA on mobile and btn up fixed elements
	let lastScrollTop = 0;
	function menuFixed() {
		// Header Active Class
		if ($(window).scrollTop() > 20) {
			$('.header').addClass('header-active');
		} else {
			$('.header').removeClass('header-active');
		}
		// CTA on mobile show/hide
		let st = $(this).scrollTop();
		let header = $('header.header');
		if (header.hasClass('header-mobile')) {
			if ($(window).scrollTop() > 350) {
				if (st >= lastScrollTop) {
					header.addClass('header-scroll');
				} else {
					header.removeClass('header-scroll');
				}
			}
			lastScrollTop = st;
		}
		// Btn Up Active Show/Hide
		if ($(this).scrollTop() > 500) {
			$('#scrollToTop').addClass('btn-up-active');
		} else {
			$('#scrollToTop').removeClass('btn-up-active');
		}
	}

	$(window).bind('scroll', menuFixed);

	// TODO scroll body to 0px on click
	$('#scrollToTop').on('click', function (event) {
		event.preventDefault();
		$('body,html').animate(
			{
				scrollTop: 0,
			},
			700,
		);
		$(this).removeClass('btn-up-active');
	});

	// TODO HD Modal
	$('.open-hd-modal').on('click', function () {
		console.log(this);
		let hdModalContentType = $(this).data('hd-modal-content-type');
		let hdModalContent = $(this).data('hd-modal-content');
		let hdModalHTML = '<div class="hd-modal">';
		let hdContainer = $('#hd-modal-container .modal-container-video');
		hdModalHTML +=
			'<div class="hd-modal-close">' +
			'<svg clip-rule="evenodd" width="24" height="24" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m12 10.93 5.719-5.72c.146-.146.339-.219.531-.219.404 0 .75.324.75.749 0 .193-.073.385-.219.532l-5.72 5.719 5.719 5.719c.147.147.22.339.22.531 0 .427-.349.75-.75.75-.192 0-.385-.073-.531-.219l-5.719-5.719-5.719 5.719c-.146.146-.339.219-.531.219-.401 0-.75-.323-.75-.75 0-.192.073-.384.22-.531l5.719-5.719-5.72-5.719c-.146-.147-.219-.339-.219-.532 0-.425.346-.749.75-.749.192 0 .385.073.531.219z" fill="#fff"/></svg></div>';

		if (hdModalContentType === 'youtube') {
			hdModalHTML =
				hdModalHTML +
				'<div class="hd-modal-before"><iframe src="https://www.youtube.com/embed/' +
				hdModalContent +
				'?autoplay=1&mute=1" allow="autoplay" allowfullscreen></iframe></div>';
		}
		if (hdModalContentType === 'file') {
			hdModalHTML =
				hdModalHTML +
				'<div class="hd-modal-before"><iframe src="' +
				hdModalContent +
				'?autoplay=1&mute=1" allow="autoplay" allowfullscreen></iframe></div>';
		} else if (hdModalContentType === 'wistia') {
			hdModalHTML += `<div class="hd-modal-before"><iframe src="https://fast.wistia.net/embed/iframe/${hdModalContent}" allowfullscreen frameborder="0" scrolling="no" class="wistia_embed" name="wistia_embed" allow="autoplay; fullscreen" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; border: none;"></iframe></div><script src="https://fast.wistia.com/embed/medias/${hdModalContent}.jsonp" async></script><script src="https://fast.wistia.com/assets/external/E-v1.js" async></script>`;
		} else {
			hdModalHTML = hdModalHTML + hdModalContent;
		}
		hdContainer.append(hdModalHTML);
		$('.modal-container').addClass('active');
	});

	$(document).on('click', '.hd-modal-close, #hd-modal-container', function (e) {
		if (
			($(this).is('#hd-modal-container') && !$(e.target).closest('.hd-modal').length) ||
			$(this).hasClass('hd-modal-close')
		) {
			$('.modal-container').removeClass('active');
			$('#hd-modal-container .modal-container-video').empty();
		}
	});

	// TODO Table of content
	$('.blogSidebar .contents').on('click', function () {
		$(this).toggleClass('active');
		$('.contents-wrap').slideToggle(500);
		if ($(this).hasClass('active')) {
			$('.js-fix').text('Close');
		} else {
			$('.js-fix').text('Expand');
		}
	});

	// TODO Swiper inits
	new Swiper('.client-testimonials-slider .swiper', {
		slidesPerView: 1,
		spaceBetween: 15,
		speed: 1000,
		loop: true,
		autoHeight: false,
		observeParents: true,
		observeSlideChildren: true,
		autoplay: {
			delay: 5000,
			disableOnInteraction: false,
			pauseOnMouseEnter: true,
		},
		navigation: {
			nextEl: '.client-testimonials-slider .button-next',
			prevEl: '.client-testimonials-slider .button-prev',
		},
		pagination: {
			el: '.client-testimonials-slider .swiper-pagination',
			clickable: true,
		},
		breakpoints: {
			768: {
				slidesPerView: 2,
				spaceBetween: 20,
			},
			1400: {
				slidesPerView: 3,
				spaceBetween: 35,
			},
		},
	});

	// TODO Tabs
	function tabsGlobal(on, target, tabsWrap, tabActive, unActive, boxWrap, boxItem, fade = 300) {
		$(target).on(on, function (event) {
			event.preventDefault();
			if ($(this).hasClass(tabActive)) {
				return false;
			}
			$(tabsWrap)
				.find('.' + tabActive)
				.removeClass(tabActive)
				.addClass(unActive);
			$(this).addClass(tabActive).removeClass(unActive);
			$(boxItem).hide();
			$(boxWrap)
				.find('.' + $(this).attr('name'))
				.stop(true)
				.fadeIn(fade);
		});
	}

	tabsGlobal(
		'click',
		'.education-buttons button',
		'.education-buttons',
		'active',
		'unactive',
		'.education-boxes',
		'.education-box',
		500,
	);
})(jQuery);
